import { FuseAnimate } from "@fuse";
import _ from "@lodash";
import { AppBar, DialogActions, DialogContent, IconButton, Toolbar, Typography, withStyles } from "@material-ui/core";
import XAPPDialog from "app/Core/Components/Dialog/XAPPDialog";
import XAPPComponent from "app/Core/Components/XAPPComponent/XAPPComponent";
import * as AppActions from "app/store/actions";
import MobileDetect from "mobile-detect";
import React from "react";
import { MdClose } from "react-icons/md";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import GerenciadorProcessoApp from "../../GerenciadorProcesso/GerenciadorProcessoApp";
import * as Actions from "../Store/Actions/MinhasTarefasActions";


const md = new MobileDetect(window.navigator.userAgent);

const styles = theme => ({
    paper: {
        border: "1px solid " + theme.palette.divider,
        //marginBottom: "24px",
        padding: "4px"
    },
    spanlabel: {
        top: 9,
        left: 15,
        position: "relative",
        backgroundColor: theme.palette.background.paper,
        paddingRight: 5,
        paddingLeft: 5,
        fontSize: 12.5,
        fontFamily: "Muli,Roboto,\"Helvetica\",Arial,sans-serif",
        color: theme.palette.text.secondary,
        maxWidth: "140px",
    }
});

const newTarefaState = {
    idtarefa: null,
    titulo: null,
    tipo: null,
    requeridos: null,
    descricao: null,
    observacao: null,
    idfluxo: null,
    fluxo: "{}",
    formulario: {},
    pessoaformulario: {}
};

const state = {
    form: { ...newTarefaState },
    tagMenuEl: null,
    tabValue: 0
};

class IniciarTarefaDialog extends XAPPComponent {

    state = { ...state };

    componentDidMount() {
        if (this.props.open.idtarefa !== undefined && this.props.open.idtarefa !== null) {
            var obj = this.props.open;
            if (this.props.data && this.props.data !== null) {
                obj.formulario = this.props.data;
            }
            obj.idformulario = obj.jsonpasso.formulario;
            this.setState({ form: obj });
        }
        else {
            this.setState({ form: newTarefaState });
        }
    }

    componentDidUpdate(prevProps, prevState) {
        if (this.props.error) {
            this.props.showMessage({
                message: this.props.error,
                variant: "error"
            });
            this.props.error = null;
        }
        if (this.props.warning) {
            this.props.showMessage({
                message: this.props.warning,
                variant: "warning"
            });
            this.props.warning = null;
        }
        if (this.props.info) {
            this.props.showMessage({
                message: this.props.info,
                variant: "success"
            });
            this.props.info = null;
        }
    }

    handleChange = (event) => {
        const form = _.set({ ...this.state.form }, event.target.name, event.target.type === "checkbox" ? event.target.checked : event.target.value);
        this.setState({ form });
    };

    onClose = () => {
        this.props.openDialog(null);
        this.props.listFilter();
    };

    handleFormulario = (_AValue) => {
        this.setState({ form: _.set({ ...this.state.form }, "formulario", _AValue) });
    };

    setRequeridos = (_ARequeridos) => {
        this.setState({ form: { ...this.state.form, "requeridos": _ARequeridos } });
    };

    canBeSubmitted = () => {
        return true;
    };

    getNextStep = (_AID) => {
        const { getTarefa, xappRouteParams, parametros, listFilter } = this.props;
        getTarefa(_AID, xappRouteParams, parametros);
        listFilter();
    };

    render() {
        const { xappRouteParams, TagsTarefa, classes, open, readOnly, parametros } = this.props;
        const { form, tabValue } = this.state;
        return (
            <XAPPDialog
                id="IniciarTarefa"
                onClose={this.onClose}
                open={open !== null}
                fullWidth
                maxWidth="sm"
            >
                <AppBar position="static" elevation={1}>
                    <Toolbar className="flex w-full min-h-0">
                        <Typography variant="subtitle1 text-white">
                            {open.jsonpasso && open.jsonpasso.titulo}
                        </Typography>
                        <div style={{ flex: 1 }} />
                        <IconButton
                            key="close"
                            aria-label="Close"
                            className="p-6"
                            onClick={this.onClose}
                        >
                            <MdClose className="text-20 text-white" />
                        </IconButton>
                    </Toolbar>
                </AppBar>

                <DialogContent classes={{ root: "p-0" }}>
                    {!_.isUndefined(form.pessoaformulario) && !_.isNull(form.pessoaformulario) ?
                        <div className="flex flex-col flex-1 items-center justify-center p-16">
                            <div className="max-w-512 text-center">
                                <FuseAnimate delay={500}>
                                    {!_.isUndefined(form.obj) && !_.isNull(form.obj) ?
                                        <Typography color="textSecondary" className="mb-16">
                                            {`Agendamento do(a) ${this.getDicionario("cliente", "cliente")} ${form.pessoaformulario.nome} às ${form.obj.inicio}, deseja iniciar o atendimento?`}
                                        </Typography>
                                        :
                                        <Typography color="textSecondary" className="mb-16">
                                            {"Erro ao buscar informações do agendamento, informe o administrador do sistema."}
                                        </Typography>
                                    }
                                </FuseAnimate>
                            </div>
                        </div>
                        :
                        <div className="flex flex-col flex-1 items-center justify-center p-16">
                            <div className="max-w-512 text-center">
                                <FuseAnimate delay={500}>
                                    <Typography color="textSecondary" className="mb-16">
                                        {`Desculpe, dados do ${this.getDicionario("cliente", "cliente")} não localizados, informe ao administrador do sistema`}
                                    </Typography>
                                </FuseAnimate>
                            </div>
                        </div>
                    }
                </DialogContent>
                {(form.conclusao === undefined || form.conclusao === null) && form.idfluxo !== null &&
                    <AppBar position="static" elevation={3} color="textSecondary">
                        <Toolbar className="flex w-full justify-end min-h-0">
                            <DialogActions className="gap-6">
                                <GerenciadorProcessoApp
                                    Tarefa={form}
                                    passofluxo={form.passofluxo}
                                    xappRouteParams={xappRouteParams}
                                    getNext={this.getNextStep}
                                    close={this.onClose}
                                    canBeSubmitted={this.canBeSubmitted}
                                    parametros={parametros}
                                />
                            </DialogActions>
                        </Toolbar>
                    </AppBar>
                }
            </XAPPDialog>
        );
    }
}


function mapDispatchToProps(dispatch) {
    return bindActionCreators({
        getTarefa: Actions.getTarefa,
        showMessage: AppActions.showMessage,
        hideMessage: AppActions.hideMessage,
    }, dispatch);
}

function mapStateToProps({ MinhasTarefas, auth }) {
    return {
        user: auth.user.data,
        formDialog: MinhasTarefas.MinhasTarefasReducer.formDialog,
        TagsTarefa: MinhasTarefas.TagFuncionalidadeReducer["agendamento"],
    };
}


export default withStyles(styles, { withTheme: true })(connect(mapStateToProps, mapDispatchToProps)(IniciarTarefaDialog));
